import { render, staticRenderFns } from "./myershoufang.vue?vue&type=template&id=879422be&scoped=true&"
import script from "./myershoufang.vue?vue&type=script&lang=js&"
export * from "./myershoufang.vue?vue&type=script&lang=js&"
import style0 from "./myershoufang.vue?vue&type=style&index=0&id=879422be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879422be",
  null
  
)

export default component.exports